<div id="counter" class="mb-5">
    <div class="container py-5 px-lg-4">
        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-4 text-center justify-content-center">
            <!-- Legacy -->
            <div class="col" data-scroll>
                <div class="counter-item py-4 h-100">
                    <div class="icon-box mb-3">
                        <i class="fas fa-award fa-2x"></i>
                    </div>
                    <h2>25+</h2>
                    <h6 class="mb-0">Years of Legacy</h6>
                </div>
            </div>
            <!-- Departments -->
            <div class="col" data-scroll>
                <div class="counter-item py-4 h-100">
                    <div class="icon-box mb-3">
                        <i class="fas fa-university fa-2x"></i>
                    </div>
                    <h2>03</h2>
                    <h6 class="mb-0">Departments</h6>
                </div>
            </div>
            <!-- Students -->
            <div class="col" data-scroll>
                <div class="counter-item py-4 h-100">
                    <div class="icon-box mb-3">
                        <i class="fas fa-users fa-2x"></i>
                    </div>
                    <h2>1000+</h2>
                    <h6 class="mb-0">Students</h6>
                </div>
            </div>
            <!-- Teachers -->
            <div class="col" data-scroll>
                <div class="counter-item py-4 h-100">
                    <div class="icon-box mb-3">
                        <i class="fas fa-chalkboard-teacher fa-2x"></i>
                    </div>
                    <h2>50+</h2>
                    <h6 class="mb-0">Full Time Teachers</h6>
                </div>
            </div>
            <!-- PhD -->
            <div class="col" data-scroll>
                <div class="counter-item py-4 h-100">
                    <div class="icon-box mb-3">
                        <i class="fas fa-user-graduate fa-2x"></i>
                    </div>
                    <h2>80%</h2>
                    <h6 class="mb-0">Ph.D. Faculty</h6>
                </div>
            </div>
            <!-- Alumni -->
            <div class="col" data-scroll>
                <div class="counter-item py-4 h-100">
                    <div class="icon-box mb-3">
                        <i class="fas fa-graduation-cap fa-2x"></i>
                    </div>
                    <h2>10000+</h2>
                    <h6 class="mb-0">Alumni</h6>
                </div>
            </div>
        </div>
    </div>
</div>